import { render, staticRenderFns } from "./stacked-area-chart.vue?vue&type=template&id=2616cbb7"
import script from "./stacked-area-chart.vue?vue&type=script&lang=js"
export * from "./stacked-area-chart.vue?vue&type=script&lang=js"
import style0 from "./stacked-area-chart.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports